import { render } from "./resumeForm.vue?vue&type=template&id=2c786e1c&scoped=true"
import script from "./resumeForm.vue?vue&type=script&lang=js"
export * from "./resumeForm.vue?vue&type=script&lang=js"

import "./resumeForm.vue?vue&type=style&index=0&id=2c786e1c&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c786e1c"]])

export default __exports__